// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { fetchNewAntennaCode } from 'helpers/api'
import getNewAntennaInitialValues from './getNewAntennaInitialValues'
import { UNCAUGHT_ERROR } from 'errors'

const setNewAntennaInitialValues = async (patterns, unitType) => {
  const details = {
    error: '',
    initialValues: getNewAntennaInitialValues(patterns, unitType),
  }

  // since we're making a new antenna, we'll need a new, valid antenna code to assign
  // to the form. grab that from the api then fire up the form.
  // NOTE - if we fail here, that just means that something went wrong when
  // trying to fetch a new, valid antenna spec code.
  // So the antennaCode field would just be empty.
  // as long as that was just a hiccough in the API,
  // the user can still fill out the form and fetch a new antenna code
  // from within the form itself.
  try {
    const { entity } = await fetchNewAntennaCode()
    details.initialValues.antennaCode = entity.generatedAntennaCode
  } catch (err) {
    console.warn(err)
    details.error = err.message || UNCAUGHT_ERROR
  }

  return details
}

export default setNewAntennaInitialValues
